import { isEqual, sortBy } from "lodash";
import { ALL_VALUES, IFilterDataItem } from "./filtersOptions";
import { IRadioButtonItem } from "./RadioButtonsFilter/RadioButtonsFilter";

export const NUMBER = "number";
export const PRIMITIVES_ARRAY = "primitives_array";
export const FILTER_DATA_ITEMS_ARRAY = "filter_data_items_array";

export const hasChangedSavedValues = (
  value1: number | (number | string | IFilterDataItem)[],
  value2: number | (number | string | IFilterDataItem)[],
  dataType: string
): boolean => {
  if (typeof value1 === typeof value2) {
    switch (dataType) {
      case NUMBER: {
        return value1 !== value2;
      }
      case PRIMITIVES_ARRAY: {
        return !isEqual(
          sortBy(value1 as (string | number)[]),
          sortBy(value2 as (string | number)[])
        );
      }
      case FILTER_DATA_ITEMS_ARRAY: {
        if (
          Array.isArray(value1) &&
          Array.isArray(value2) &&
          value1.length === value2.length
        ) {
          const [sortedArray1, sortedArray2] = [value1, value2].map(arr =>
            arr.sort((a: IFilterDataItem, b: IFilterDataItem) =>
              a.label > b.label ? 1 : -1
            )
          );

          return !sortedArray1.every((item, index) => {
            return isEqual(item, sortedArray2[index]);
          });
        }

        return true;
      }
    }
  }

  return true;
};

export const hasSelectedFilters = (
  values: (number | (string | number | IFilterDataItem)[])[],
  minSliderValue?: number,
  maxSliderValue?: number
): boolean => {
  return values.some(value => {
    let result: boolean;

    if (typeof value === "number") {
      result = Boolean(value);
    } else if (Array.isArray(value)) {
      if (value.length === 2 && value.every(item => typeof item === "number")) {
        result = value[0] !== minSliderValue || value[1] !== maxSliderValue;
      } else {
        result = Boolean(value.length);
      }
    }

    return result;
  });
};

export const getCheckboxesFilterValue = (items: string[]): string[] => {
  if (Array.isArray(items)) {
    return items
      .filter(item => item !== ALL_VALUES)
      .flatMap(item => (item.indexOf("/") !== -1 ? item.split("/") : item));
  }

  return null;
};

export const createAllValuesItem = (title: string): IFilterDataItem => {
  return {
    label: `All ${title}`,
    value: ALL_VALUES
  };
};

export const createCustomAllValuesItem = (title: string): IRadioButtonItem => {
  return {
    label: title,
    value: 0
  };
};
